





import Vue from 'vue'

import nonLogin from '@/containers/Auth/nonLogin'
import AppClose from '@/containers/Auth/AppClose'

import FetchNewsListUseCase from '@/usecases/news/FetchNewsListUseCase'
import FetchVoicesUseCase from '@/usecases/voice/FetchVoicesUseCase'

import { isWebViewApp } from '@/plugins/userAgent'

export default Vue.extend({
  components: {
    nonLogin,
    AppClose
  },
  layout: 'top',
  middleware: ['checkAuth'],
  async fetch({ $newsRepository, $voiceRepository, $microcmsGateway, $pagerRepository, $metaRepository }) {
    const fetchNewsList = new FetchNewsListUseCase({
      microcmsGateway: $microcmsGateway,
      newsRepository: $newsRepository
    })

    const fetchVoices = new FetchVoicesUseCase({
      microcmsGateway: $microcmsGateway,
      voiceRepository: $voiceRepository,
      pagerRepository: $pagerRepository
    })

    const newsPerPage = 4

    const today = $metaRepository.getLatestServerTimestamp()

    try {
      await Promise.all([fetchNewsList.execute({ perPage: newsPerPage, today }), fetchVoices.execute({ page: 1 })])
    } catch (e) {
      // TODO: Handle Error
      console.log(e)
    }
  },
  computed: {
    isWebViewApp(): boolean {
      return isWebViewApp()
    }
  }
})
